module.exports = __webpack_public_path__ + "5ef02027deb4494c3eaaea4afcf530d4.png";